import { Address } from '../forms/address/types';
import ajax from '../utils/ajax';
import VerifyAddressResponse from './VerifyAddressResponse';
import {
  IAddressSearchResponse,
  IAddressOption,
  IFormattedAddress,
} from './types';

async function verifyAddress(address: Address): Promise<VerifyAddressResponse | []> {
  try {
    const response: IAddressSearchResponse[] | [] = await ajax.post(
      '/api/Verification/Verify',
      {
        street1: address.address1,
        street2: address.address2,
        city: address.city,
        country: address.countryId,
        postalCode: address.postalCode,
        state: address.state,
      },
    );

    return new VerifyAddressResponse(response, address.countryId);
  } catch (error) {
    return [];
  }
}

async function getAddress(
  countryId: string,
  addressId: string,
): Promise<Address> {
  const fallbackValue = '';

  try {
    const response: IFormattedAddress | null = await ajax.post(
      '/api/Verification/GetAddress',
      {
        country: '0',
        id: addressId,
      },
    );

    if (!response) {
      return {
        address1: fallbackValue,
        address2: fallbackValue,
        city: fallbackValue,
        state: fallbackValue,
        postalCode: fallbackValue,
        countryId: fallbackValue,
      };
    }

    return {
      address1: response.street1,
      address2: response.street2 || fallbackValue,
      city: response.city,
      state: response.state,
      postalCode: response.postalCode,
      countryId,
    };
  } catch (ex) {
    return {
      address1: fallbackValue,
      address2: fallbackValue,
      city: fallbackValue,
      state: fallbackValue,
      postalCode: fallbackValue,
      countryId: fallbackValue,
    };
  }
}

async function getSuggestedAddresses(
  address: Address,
): Promise<IAddressOption[] | []> {
  try {
    const verifyResponse = await verifyAddress(address);

    if (verifyResponse instanceof VerifyAddressResponse) {
      return verifyResponse.suggestedAddresses;
    }
  } catch (error) {}

  return [];
}

export default {
  getAddress,
  getSuggestedAddresses,
  verifyAddress,
};
